import { useRouter } from 'vue-router'
import { useAuthStore } from 'src/stores'
import { storeToRefs } from 'pinia'

export default function useAccess() {
  const router = useRouter()
  const authStore = useAuthStore()
  const authStoreRef = storeToRefs(authStore)

  /** @type {number[]} */
  const userAccesses = authStoreRef.role.value?.access || []

  /* -------------------------------- Functions ------------------------------- */
  /**
   * @param {number[]} userAccessesParam
   * @param {number[]} accessList
   */
  const canFoundAccess = (userAccessesParam, accessList) => {
    for (const access of userAccessesParam) {
      if (accessList.includes(access)) return true
    }

    return false
  }

  /**
   * @param {number[]} accessList
   */
  const canPassAccess = (accessList) => {
    return (
      authStore.portalUser.role_id === 1 ||
      !accessList ||
      !accessList.length ||
      canFoundAccess(userAccesses, accessList)
    )
  }

  /**
   * @param {string} component_name
   */
  const canComponentPassAccess = (component_name) => {
    const routes = router.getRoutes()
    const route = routes.find((r) => r.name === component_name)

    /** @type {number[]} accesses */
    const routeAccesses = route?.meta?.access

    return canPassAccess(routeAccesses)
  }

  return { canPassAccess, canComponentPassAccess }
}
